export default __webpack_public_path__ + "static/media/svg-5.5afff8f9.svg";